import { render } from "./ReceiveAction.vue?vue&type=template&id=93de637e"
import script from "./ReceiveAction.vue?vue&type=script&lang=js"
export * from "./ReceiveAction.vue?vue&type=script&lang=js"

import "./ReceiveAction.vue?vue&type=style&index=0&id=93de637e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__